import documentosApi from '../../../services/documentosApi';
import logger from '../../../utils/logger';

// Regras de negócio fixas do Protocolo Online desta OAB (definidas pelo time de negócio).
// TIPO_DOCUMENTO_* exportados porque quem só tem o tipoDocumentoProcesso (ex:
// pendenciasService, resolvendo pendência de documento indeferido) precisa
// saber o nome desses 2 tipos — o Protocolo Online não tem documentConfig
// como os pedidos do catálogo de departamentos.
const TIPO_ASSUNTO_PROTOCOLO_ONLINE = '430';
export const TIPO_DOCUMENTO_REQUERIMENTO = 433;
export const TIPO_DOCUMENTO_ADICIONAL = 281; // Documentos Diversos
// Tipo usado nos anexos opcionais até 2026-09 (na verdade é "Contrato de Distrato
// de Associado"). Não é mais enviado, mas protocolos antigos ainda podem ter
// pendência de documento indeferido com esse tipo.
export const TIPO_DOCUMENTO_ADICIONAL_LEGADO = 460;

/**
 * Anexa os documentos do Protocolo Online via API de GED: o PDF obrigatório do
 * requerimento (tipo 433) e os anexos opcionais (tipo 281 - Documentos Diversos). Só deve ser chamado
 * depois que o requerimento (e, se houver, o protocolo) já existirem no banco.
 * @param {Object} params
 * @param {string|number} params.requerimentoId
 * @param {string|number} [params.protocoloId] - apesar do nome, é o ID da linha em
 *   DocumentoProtocolo (não o Protocolo.ID) — é isso que cria o vínculo com DocumentoProtocolo.
 *   Ver protocoloService.finalizarProtocoloOnline, que já devolve esse valor certo.
 * @param {string|number} params.usuarioId
 * @param {File} params.requerimentoFile - PDF obrigatório do requerimento
 * @param {File[]} [params.outrosArquivos] - anexos opcionais
 * @returns {Promise} Resposta da API
 */
async function anexarDocumentosProtocoloOnline({ requerimentoId, protocoloId, usuarioId, requerimentoFile, outrosArquivos = [] }) {
  if (!requerimentoId) {
    throw new Error('requerimentoId é obrigatório');
  }
  if (!usuarioId) {
    throw new Error('usuarioId é obrigatório');
  }
  if (!requerimentoFile) {
    throw new Error('O arquivo do requerimento é obrigatório');
  }

  const arquivos = [requerimentoFile, ...outrosArquivos];
  const tipos = [TIPO_DOCUMENTO_REQUERIMENTO, ...outrosArquivos.map(() => TIPO_DOCUMENTO_ADICIONAL)];

  const formData = new FormData();
  formData.append('RequerimentoId', requerimentoId);
  if (protocoloId) {
    formData.append('protocoloId', protocoloId);
  }
  formData.append('tipoAssunto', TIPO_ASSUNTO_PROTOCOLO_ONLINE);
  formData.append('usuarioId', usuarioId);
  formData.append('tipoDocumentoProcesso', tipos.join(','));
  arquivos.forEach((arquivo) => formData.append('arquivos', arquivo));

  try {
    const response = await documentosApi.post('/documentos/anexar', formData);
    return response.data;
  } catch (error) {
    logger.error('Erro ao anexar documentos:', error);
    const mensagem = error.response?.data?.error || error.response?.data?.message || error.message;
    throw new Error(mensagem || 'Erro ao anexar documentos');
  }
}

export const documentoAnexoService = { anexarDocumentosProtocoloOnline };
